import React from 'react'
import { Link } from 'react-router-dom'
import probnr from '../../../../assets/img/services_mn.webp'

function ServicesTopSec() {
  return (
    <section className='hmslder-sec abt-sec'>
        <div className='breadcrumbs'>
            <div className='container'>
             <ul>
               <li><Link to='/'>Home</Link> </li> 
               <li>Our Services</li>   
             </ul> 
             </div> 
        </div>
        <div className='container'>
           <div className='hmslder-txt'>
              <h2>We're <span>Proud</span> of The <span>Work</span> We've Done </h2>
              <p>We are built on the idea of balance. We think about the people using our  products, and how we can make their lives better through technology.  Our approach is to constantly look ahead to what’s next so that your  digital solution is ready for the now.</p>
            </div> 
           <div className='hmslder-img'>
            <img src={probnr} alt='Our Services' width={1200} height={600} loading="lazy" />
            </div>  
        </div>
    </section>
  )
}

export default ServicesTopSec
